// A ticket whose sales have not started yet but is shown as a preview (AIRLST-4607). The Checkout API
// lists it with `sales_status: 'not_yet_available'` and rejects any attempt to buy it.
export const isTicketComingSoon = (ticket) =>
  ticket?.sales_status === 'not_yet_available'

// Formatted in the event's timezone with its abbreviation (e.g. "20 Oct 2026, 10:00 CEST"), matching
// the CenterStage registration form, so every visitor reads the same moment.
export const formatTicketSalesStart = (salesStart, timeZone, locale) =>
  new Date(salesStart).toLocaleString(locale || undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timeZone || undefined,
    timeZoneName: 'short',
  })
